export default "__VITE_ASSET__83418e4a__"